import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { StripeCardComponentDef } from '@df/module-stripe/stripe-card.component.def';
import { Stripe } from '@df/module-stripe/stripe.namespace';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
@Component({
    selector: 'stripe-card',
    templateUrl: './stripe-card.html',
    styleUrls: ['./stripe-card.scss'],
    standalone: true,
    imports: [InputWrapComponent, InputWrapBodyDirective, FormsModule, NgClass, TranslationModule, CheckboxComponent],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class StripeCardComponent extends StripeCardComponentDef implements OnInit {
    protected isChanged = false;
    protected onBlur = false;
    protected numberEvent: Stripe.ICardNumberElementChangeEvent | null = null;
    protected expiryEvent: Stripe.ICardNumberElementChangeEvent | null = null;
    protected cvcEvent: Stripe.ICardNumberElementChangeEvent | null = null;

    protected override getCardNumberOptions(): Stripe.ICreateCardNumberOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#212121' } } };
    }
    protected override getCardExpiryOptions(): Stripe.ICreateCardExpiryOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#212121' } } };
    }
    protected override getCardCvcOptions(): Stripe.ICreateCardCvcOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#212121' } } };
    }
    protected override getSubmittedCardNumberOptions(): Stripe.ICreateCardNumberOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#FF2F2F' } } };
    }
    protected override getSubmittedCardExpiryOptions(): Stripe.ICreateCardExpiryOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#FF2F2F' } } };
    }
    protected override getSubmittedCardCvcOptions(): Stripe.ICreateCardCvcOptions {
        return { style: { base: { lineHeight: '3rem', color: '#212121' }, invalid: { color: '#FF2F2F' } } };
    }

    protected override onCardNumberChange(event: Stripe.ICardNumberElementChangeEvent): void {
        this.isChanged = true;
        this.onBlur = true;
        this.numberEvent = event;
        super.onCardNumberChange(event);
    }

    protected override onCardExpiryChange(event: Stripe.ICardNumberElementChangeEvent): void {
        this.isChanged = true;
        this.onBlur = true;
        this.expiryEvent = event;
        super.onCardExpiryChange(event);
    }

    protected override onCardCvcChange(event: Stripe.ICardNumberElementChangeEvent): void {
        this.isChanged = true;
        this.onBlur = true;
        this.cvcEvent = event;
        super.onCardCvcChange(event);
    }

    protected displayCardIcon(type: string): boolean {
        return this.selectedCardType === type || !this.selectedCardType || this.selectedCardType === 'unknown';
    }

    override get cardNumberError(): string {
        if (!this.submitted) {
            return this.numberEvent?.error?.message || '';
        } else {
            return super.cardNumberError;
        }
    }

    override get cardExpiryError(): string {
        if (!this.submitted) {
            return this.expiryEvent?.error?.message || '';
        } else {
            return super.cardExpiryError;
        }
    }

    override get cardCvcError(): string {
        if (!this.submitted) {
            return this.cvcEvent?.error?.message || '';
        } else {
            return super.cardCvcError;
        }
    }
}
